import * as ko from 'knockout'
import { component } from 'knockout-decorators'

import type { EventItem } from '@tixa/schema'
import { Language, formatTranslation } from '~/utils/language'

import source from './age-restriction.html?raw'
import './age-restriction.less'

type AgeRestrictionsInput =
  | EventItem['ageRestrictions']
  | undefined
  | ko.Subscribable<EventItem['ageRestrictions'] | undefined>

@component('age-restriction', source)
export class AgeRestriction {
  public labels: ko.PureComputed<string[]>
  public hasLabels: ko.PureComputed<boolean>

  constructor(params: { ageRestrictions?: AgeRestrictionsInput }) {
    this.labels = ko.pureComputed(() => {
      const raw = ko.unwrap(params.ageRestrictions)
      if (!raw) return []

      const t = Language.getInstance().translations

      const labels: string[] = []

      for (const row of raw) {
        if (typeof row.ageLimit === 'number') {
          if (row.ageLimit === 0) {
            labels.push(t.ageRestrictionNone)
          } else {
            labels.push(
              formatTranslation(t.ageRestrictionLabel, {
                restrictedAge: `${row.ageLimit}`,
              })
            )
          }
        }

        if (typeof row.eventIsFreeUnderAge === 'number') {
          if (row.eventIsFreeUnderAge === 0) {
            labels.push(t.ageRestrictionNoFreeEntry)
          } else {
            labels.push(
              formatTranslation(t.ageRestrictionFreeEntryLabel, {
                freeEntryAge: row.eventIsFreeUnderAge,
              })
            )
          }
        }
      }

      return labels
    })

    this.hasLabels = ko.pureComputed(() => this.labels().length > 0)
  }
}
